<template>
  <v-container fluid>
    <v-row class="mb-4" wrap>
      <v-card class="pa-4 rounded-xl elevation-2" style="background-color: #fbeee6; position: relative;">
        <!-- Exit icon -->
        <v-icon color="red" size="24" class="cursor-pointer" style="position: absolute; top: 8px; right: 8px;"
          @click="markTradeExited">
          mdi-exit-to-app
        </v-icon>

        <v-row dense>
          <v-col cols="6" class="text-left text-body-2 font-weight-medium">Strategy:</v-col>
          <v-col cols="6" class="text-left text-body-2">{{ strategy.strategyName }}</v-col>

          <v-col cols="6" class="text-left text-body-2 font-weight-medium">Strategy Type:</v-col>
          <v-col cols="6" class="text-left text-body-2">{{ strategy.strategyType }}</v-col>

          <v-col cols="6" class="text-left text-body-2 font-weight-medium">PNL:</v-col>
          <v-col cols="6" class="text-left text-body-2">
            <span :class="getColorClass(strategy.pnl)">{{ strategy.pnl }}</span>
          </v-col>

          <v-col cols="3" class="text-left text-body-2 font-weight-medium">Total DB:</v-col>
          <v-col cols="3" class="text-left text-body-2">
            <span :class="getColorClass(strategy.totalDebit)">{{ strategy.totalDebit }}</span>
          </v-col>

          <v-col cols="3" class="text-left text-body-2 font-weight-medium">Total CR:</v-col>
          <v-col cols="3" class="text-left text-body-2">
            <span :class="getColorClass(strategy.totalCredit)">{{ strategy.totalCredit }}</span>
          </v-col>

          <v-col cols="6" class="text-left text-body-2 font-weight-medium">Total CR/DB:</v-col>
          <v-col cols="6" class="text-left text-body-2">
            <span :class="getColorClass(strategy.totalCreditDebit)">{{ strategy.totalCreditDebit }}</span>
          </v-col>
        </v-row>
      </v-card>
    </v-row>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :timeout="3000" color="success">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script setup>
import { reactive } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  strategy: Object,
})

const store = useStore()

const snackbar = reactive({
  show: false,
  message: '',
})

const getColorClass = (value) => {
  return Number(value) < 0 ? 'text-red' : 'text-green'
}

const markTradeExited = async () => {
  console.log('📦 mark trade exited in component', props.strategy.tradeId)
  try {
    const res = await store.dispatch('trades/markTradeExited', { tradeId: props.strategy.tradeId })
    console.log('📦 mark trade exited API response:', res)
    snackbar.message = res || 'Trade exited successfully'
    snackbar.show = true
  } catch (e) {
    console.error('❌ mark trade exited API error:', e)
    snackbar.message = e?.response?.data?.message || e?.message || 'Error exiting trade'
    snackbar.show = true
  }
}

</script>
